import ApiService from "service/Api";
import { GetManualReceiptRafflePayloadTypes } from "utilities/types/ReceiptRaffle";

const ReceiptRaffleService = {
  getManualReceiptRaffle: async (
    payload: GetManualReceiptRafflePayloadTypes
  ) => {
    const { phoneNumber, imageReceipt } = payload;

    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; multipart/form-data; charset=utf-8",
      },
      data: {
        phone_number: phoneNumber,
        image: imageReceipt,
      },
      url: "/admin/raffles/get-manual-receipt",
    };

    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      return data;
    } catch (error) {
      throw error;
    }
  },
};

export default ReceiptRaffleService;
